module.exports = __webpack_public_path__ + "static/media/creditcard.59251362.svg";